// extracted by mini-css-extract-plugin
export default {"error":"NaoEncontrada_error__S7KRV","botaoRedirecionar":"NaoEncontrada_botaoRedirecionar__uVUAG"};